import { TextInterface } from '@email-editor/ui'
import { useUpdateNestedProp, useUpdateNestedProps, useUpdateProp } from '../hooks/useUpdaters'
import Padding, { PaddingsUpdater, PaddingUpdater } from '../options/Padding'
import Spacing from '../options/Spacing'

type TextSettingsProps = {
  entity: TextInterface
}

const TextSettings = ({ entity }: TextSettingsProps) => {
  const updateProp = useUpdateProp(entity)
  const updateNestedProp = useUpdateNestedProp(entity)
  const updateNestedProps = useUpdateNestedProps(entity)
  return (
    <>
      <Spacing lineHeight={entity.lineHeight} update={updateProp('lineHeight')} />
      <Padding
        padding={entity.padding}
        update={updateNestedProp('padding') as PaddingUpdater}
        updatePaddings={updateNestedProps('padding') as PaddingsUpdater}
      />
    </>
  )
}

export default TextSettings
